import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { ScienceSection } from '../components/ScienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DifferentialSection } from '../components/DifferentialSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { EvidenceSection } from '../components/EvidenceSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { FAQSection } from '../components/FAQSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-dark w-full overflow-x-hidden font-body" data-id="element-231">
      <AnnouncementBar data-id="element-232" />
      <Navbar data-id="element-233" />
      <main data-id="element-234">
        <HeroSection data-id="element-235" />
        <DiagnosisSection data-id="element-236" />
        <ScienceSection data-id="element-237" />
        <TestimonialsSection data-id="element-238" />
        <DifferentialSection data-id="element-239" />
        <BenefitsSection data-id="element-240" />
        <ProtocolSection data-id="element-241" />
        <EvidenceSection data-id="element-242" />
        <PurchaseSection data-id="element-243" />
        <FAQSection data-id="element-244" />
      </main>
      <FooterSection data-id="element-245" />
    </div>;
}